import { toast } from "react-toastify";
import { getHomeRequest, saveHomeRequest } from "../../requests/home";
export const types = {
  GET_HOME_REQUEST: 'GET_HOME_REQUEST',
  GET_HOME_SUCCESS: 'GET_HOME_SUCCESS',
  GET_HOME_FAILURE: 'GET_HOME_FAILURE',
  SAVE_HOME_REQUEST: 'SAVE_HOME_REQUEST',
  SAVE_HOME_SUCCESS: 'SAVE_HOME_SUCCESS',
  SAVE_HOME_FAILURE: 'SAVE_HOME_FAILURE',
}

export const getHomeSections = (type = 'AUTOMATIC_CHANNEL') => {
  return (dispatch) => {
    dispatch({ type: types.GET_HOME_REQUEST });
    getHomeRequest(type)
      .then(response => {
        dispatch({
          type: types.GET_HOME_SUCCESS,
          payload: response.data
        })
      })
      .catch(error => {
        dispatch({
          type: types.GET_HOME_FAILURE,
          error
        })
      })
  }
}

export const saveHomeSections = data => {
  return (dispatch) => {
    dispatch({ type: types.SAVE_HOME_REQUEST });
    saveHomeRequest(data)
      .then(() => {
        dispatch({
          type: types.SAVE_HOME_SUCCESS
        })
        toast.success('تغییرات با موفقیت ذخیره شد', {toastId: 'home-saved'})
      })
      .catch(error => {
        dispatch({
          type: types.SAVE_HOME_FAILURE,
          error
        })
      })
  }
}
